import {User} from "@commons/models/domain/User";

export class UserViewModel {

  get initials(): string {
    return this.user ?
      `${this.user?.FirstName ? this.user.FirstName[0] : ''}${this.user?.LastName ? this.user?.LastName[0] : ''}`.toUpperCase()
      : '';
  }

  constructor(public user: User) {
  }

  toString(): string {
    return `${this.user?.FirstName} ${this.user?.LastName} ${this.user?.Email} ${this.user?.Phone}`;
  }

  getFullName(): string {
    return `${this.user?.FirstName} ${this.user?.LastName}`;
  }
}
